import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from './../../services/user.service';
import { AdminApiService } from './../../services/admin.service';
import { RSAHelper } from '../../models/RSAHelper';
@Component({
  selector: 'app-pingcallback',
  templateUrl: './pingcallback.component.html',
  styleUrls: ['./pingcallback.component.scss']
})
export class PingcallbackComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    public router: Router, private userService: UserService,private restApi:AdminApiService,public RASHelper: RSAHelper) {  
    let codevalue;
  }

  ngOnInit(): void {
    let codevalue;
  }

  ngAfterViewInit() {
  //   let codevalue;
    var codevalue;
    let that = this;

    this.route.queryParams.subscribe(
      params => {
        codevalue = (params['code']);
        localStorage.removeItem('pingID_code');
        localStorage.setItem('pingID_code', codevalue);
      });

    // REQUEST TO SIGNIN-OIDC
    this.restApi.SignInOidc({ code: codevalue }).subscribe({
      next(data: any) {
        if (data.description == "Success") {
          localStorage.removeItem('ping_un');
          localStorage.removeItem('musherataccesstoken');
          localStorage.setItem('musherataccesstoken', data.data.token);
          that.checkValidSession(data.data.token)
        }
      },
      error(err) {
        console.log('ERROR: ', err);
      },
    })
   }

checkValidSession(token = '') {
  this.restApi.verifyPingAccessToken(token).subscribe({
    next: (data: any) => {
      const result = JSON.parse(data.data);
      const isActive = result.active;

      if (isActive) {
        let email: string | undefined;

        if (result.email) { 
          email = result.email.trim(); 
        } 
        if (email && !email.includes('@')) 
        { 
          email += '@dewa.gov.ae'; 
        }

        localStorage.setItem('ping_un', this.RASHelper.encryptWithPublicKey(email));
        this.router.navigate(['/pingredirect']);
      } else {
        this.userService.logout();
      }
    },
    error: (err) => {
      console.log('ERROR: ', err);
    }
  });
}

  
}
